<template>
  <div class="merchant-withdrawal">
    <!-- 剩余运营金额 -->
    <el-card shadow="hover" class="balance-card">
      <span class="balance-label">剩余运营金额：</span>
      <span class="balance-value">¥{{ remainingBalance }}</span>
    </el-card>

    <!-- 搜索栏 -->
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" size="small">
        <el-form-item label="处理状态">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择"
            clearable
            multiple
            collapse-tags
            style="width: 200px;"
          >
            <el-option label="待处理" value="pending"></el-option>
            <el-option label="审核通过待支付" value="approved"></el-option>
            <el-option label="已支付" value="paid"></el-option>
            <el-option label="已拒绝" value="rejected"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input v-model="searchForm.merchantName" placeholder="请输入" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 280px;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card shadow="hover" class="table-card">
      <el-table
        :data="tableData"
        border
        stripe
        highlight-current-row
        row-key="id"
        style="width: 100%;"
        height="calc(100vh - 340px)"
      >
        <el-table-column prop="id" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="merchantName" label="商户名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="accountNumber" label="打款账号" width="120" align="center"></el-table-column>
        <el-table-column prop="phoneNumber" label="手机号码" width="130" align="center"></el-table-column>
        <el-table-column prop="withdrawAmount" label="提现金额" width="120" align="right">
          <template slot-scope="scope">¥{{ scope.row.withdrawAmount }}</template>
        </el-table-column>
        <el-table-column prop="remainingAmount" label="剩余可提金额" width="130" align="right">
          <template slot-scope="scope">¥{{ scope.row.remainingAmount }}</template>
        </el-table-column>
        <el-table-column prop="totalWithdrawn" label="累计已提金额" width="130" align="right">
          <template slot-scope="scope">¥{{ scope.row.totalWithdrawn }}</template>
        </el-table-column>
        <el-table-column prop="status" label="处理状态" width="140" align="center">
          <template slot-scope="scope">
            <span :class="getStatusClass(scope.row.status)">{{ getStatusText(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="applyTime" label="申请时间" width="170" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" width="170" align="center"></el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button 
              v-if="scope.row.status === 'pending'" 
              type="text" 
              size="small" 
              @click="handleAudit(scope.row)"
            >审核</el-button>
            <el-button 
              v-if="scope.row.status === 'approved'" 
              type="text" 
              size="small" 
              @click="handlePay(scope.row)"
            >支付</el-button>
            <el-button type="text" size="small" @click="showDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 审核对话框 -->
    <el-dialog
      title="审核提现申请"
      :visible.sync="auditDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="auditForm" label-width="100px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditForm.result">
            <el-radio label="pass">通过</el-radio>
            <el-radio label="reject">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="auditForm.result === 'reject'" label="拒绝原因">
          <el-input
            v-model="auditForm.reason"
            type="textarea"
            :rows="3"
            placeholder="请输入拒绝原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAudit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 支付确认对话框 -->
    <el-dialog
      title="确认支付"
      :visible.sync="payDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <p>确认向 <strong>{{ currentMerchant.merchantName }}</strong> 支付 ¥{{ currentMerchant.withdrawAmount }} 吗？</p>
      <div slot="footer">
        <el-button @click="payDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmPay">确认支付</el-button>
      </div>
    </el-dialog>

    <!-- 商户提现详情抽屉 -->
    <merchant-withdrawal-details
      :visible.sync="drawerVisible"
      :withdraw-data="selectedWithdraw"
    />
  </div>
</template>

<script>
import MerchantWithdrawalDetails from './components/merchantWithdrawalDetails.vue'

export default {
  name: 'MerchantWithdrawal',
  components: {
    MerchantWithdrawalDetails
  },
  data() {
    return {
      remainingBalance: '10142.76',
      searchForm: {
        status: [],
        merchantName: '',
        dateRange: []
      },
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      drawerVisible: false,
      selectedWithdraw: null,
      auditDialogVisible: false,
      payDialogVisible: false,
      currentMerchant: {},
      auditForm: {
        result: 'pass',
        reason: ''
      }
    }
  },
  mounted() {
    this.generateMockData()
    this.loadTableData()
  },
  methods: {
    // 生成模拟数据
    generateMockData() {
      const companyNames = [
        '张三李四有限公司', 'abcdefg有限公司', '数字科技有限公司', '农业科技有限公司',
        '创新能源集团', '智慧充电股份', '绿色出行科技', '新能源发展公司',
        '电力服务集团', '智能电网科技', '清洁能源股份', '电动车充电联盟',
        '快充技术公司', '充电桩运营中心', '能源管理科技', '充电网络股份',
        '电力投资公司', '智能充电系统', '新能源科技公司', '充电服务平台',
        '电力设备集团', '能源解决方案', '充电设施运营', '智能能源管理',
        '电力服务公司', '充电技术研究', '能源开发集团', '充电设备制造',
        '电力工程公司', '能源科技公司'
      ]
      
      const statuses = ['pending', 'approved', 'paid', 'rejected']
      
      this.allData = []
      for (let i = 1; i <= 30; i++) {
        const companyName = companyNames[Math.floor(Math.random() * companyNames.length)] + (i > 20 ? `(${i})` : '')
        const accountNumber = String(Math.floor(Math.random() * 900000) + 100000)
        const phonePrefix = ['138', '139', '150', '151', '158', '159', '186', '187', '188', '199']
        const phoneNumber = phonePrefix[Math.floor(Math.random() * phonePrefix.length)] + 
                           String(Math.floor(Math.random() * 100000000)).padStart(8, '0')
        
        const withdrawAmount = (Math.random() * 30000 + 500).toFixed(2)
        const remainingAmount = (Math.random() * 1000000 + 500000).toFixed(2)
        const totalWithdrawn = (Math.random() * 100000).toFixed(2)
        
        // 随机分配状态，待处理的稍多一些
        let status
        const rand = Math.random()
        if (rand < 0.35) status = 'pending'
        else if (rand < 0.55) status = 'approved'
        else if (rand < 0.8) status = 'paid'
        else status = 'rejected'
        
        const year = 2026
        const month = String(Math.floor(Math.random() * 2) + 1).padStart(2, '0')
        const day = String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')
        const hour = String(Math.floor(Math.random() * 24)).padStart(2, '0')
        const minute = String(Math.floor(Math.random() * 60)).padStart(2, '0')
        const second = String(Math.floor(Math.random() * 60)).padStart(2, '0')
        const applyTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`
        
        // 修改时间比申请时间晚一些
        const updateHour = String((parseInt(hour) + Math.floor(Math.random() * 3)) % 24).padStart(2, '0')
        const updateTime = `${year}-${month}-${day} ${updateHour}:${minute}:${second}`
        
        this.allData.push({
          id: i,
          merchantName: companyName,
          accountNumber: accountNumber,
          phoneNumber: phoneNumber,
          withdrawAmount: parseFloat(withdrawAmount).toLocaleString('zh-CN', { minimumFractionDigits: 2 }),
          remainingAmount: parseFloat(remainingAmount).toLocaleString('zh-CN', { minimumFractionDigits: 2 }),
          totalWithdrawn: parseFloat(totalWithdrawn).toLocaleString('zh-CN', { minimumFractionDigits: 2 }),
          status: status,
          applyTime: applyTime,
          updateTime: updateTime,
          rejectReason: status === 'rejected' ? '资料不完整，请补充后重新提交' : ''
        })
      }
      this.total = this.allData.length
    },

    // 加载表格数据
    loadTableData() {
      let filteredData = [...this.allData]
      
      // 状态过滤
      if (this.searchForm.status && this.searchForm.status.length > 0) {
        filteredData = filteredData.filter(item => 
          this.searchForm.status.includes(item.status)
        )
      }
      
      // 商户名称过滤
      if (this.searchForm.merchantName) {
        filteredData = filteredData.filter(item => 
          item.merchantName.includes(this.searchForm.merchantName)
        )
      }
      
      // 时间范围过滤
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        const startDate = new Date(this.searchForm.dateRange[0])
        const endDate = new Date(this.searchForm.dateRange[1])
        endDate.setHours(23, 59, 59, 999)
        
        filteredData = filteredData.filter(item => {
          const applyDate = new Date(item.applyTime)
          return applyDate >= startDate && applyDate <= endDate
        })
      }
      
      // 分页
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      this.tableData = filteredData.slice(start, end)
      this.total = filteredData.length
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        pending: '待处理',
        approved: '审核通过待支付',
        paid: '已支付',
        rejected: '已拒绝'
      }
      return statusMap[status] || status
    },

    // 获取状态样式类
    getStatusClass(status) {
      const classMap = {
        pending: 'status-pending',
        approved: 'status-approved',
        paid: 'status-paid',
        rejected: 'status-rejected'
      }
      return classMap[status] || ''
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.loadTableData()
    },

    // 审核
    handleAudit(row) {
      this.currentMerchant = row
      this.auditForm = {
        result: 'pass',
        reason: ''
      }
      this.auditDialogVisible = true
    },

    // 确认审核
    confirmAudit() {
      if (this.auditForm.result === 'reject' && !this.auditForm.reason.trim()) {
        this.$message.warning('请填写拒绝原因')
        return
      }
      
      // 更新数据状态
      const target = this.allData.find(item => item.id === this.currentMerchant.id)
      if (target) {
        target.status = this.auditForm.result === 'pass' ? 'approved' : 'rejected'
        target.rejectReason = this.auditForm.reason
        const now = new Date()
        target.updateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`
      }
      
      this.$message.success('审核成功')
      this.auditDialogVisible = false
      this.loadTableData()
    },

    // 支付
    handlePay(row) {
      this.currentMerchant = row
      this.payDialogVisible = true
    },

    // 确认支付
    confirmPay() {
      // 更新数据状态
      const target = this.allData.find(item => item.id === this.currentMerchant.id)
      if (target) {
        target.status = 'paid'
        const now = new Date()
        target.updateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`
      }
      
      this.$message.success('支付成功')
      this.payDialogVisible = false
      this.loadTableData()
    },

    // 显示详情
    showDetail(row) {
      this.selectedWithdraw = row
      this.drawerVisible = true
    },

    // 每页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadTableData()
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadTableData()
    }
  }
}
</script>

<style scoped lang="scss">
.merchant-withdrawal {
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  overflow: hidden;
  box-sizing: border-box;
}

.balance-card {
  flex-shrink: 0;
  padding: 12px 16px;
  
  ::v-deep .el-card__body {
    padding: 12px 16px;
  }
}

.balance-label {
  font-size: 14px;
  color: #606266;
  margin-right: 8px;
}

.balance-value {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
}

.search-card {
  flex-shrink: 0;
  
  ::v-deep .el-card__body {
    padding: 12px 16px;
  }
}

.table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
  ::v-deep .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 12px;
    overflow: hidden;
  }
}

.pagination-container {
  margin-top: 12px;
  text-align: right;
  flex-shrink: 0;
}

// 状态颜色
.status-pending {
  color: #409EFF;
  font-weight: 500;
}

.status-approved {
  color: #E6A23C;
  font-weight: 500;
}

.status-paid {
  color: #909399;
  font-weight: 500;
}

.status-rejected {
  color: #F56C6C;
  font-weight: 500;
}
</style>